import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from "../../components/helpers/axiosInstance";
import { Modal } from 'react-bootstrap';
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import Step5 from "./Steps/Step5";
import { useFormik , FormikProvider } from "formik";
import { useToast } from "../../components/notificaciones/ToastProvider";
import dayjs from "dayjs";
import es from 'dayjs/locale/es';
import { validacionContrato } from "./Validaciones/ValidacionDatos";
import { useSearch } from "../../components/search/SearchProvider";
import { useContratos } from "../../components/contratos/ContratosProvider";

/**
 * Confiurar libreria days a español
 */
dayjs.locale(es);
/**
 * Datos iniciales de datos de contrato
 * @type {{sistema: string, cliente: string, origen: string, contacto: string, email: string, tel_movil: string, tel_oficina: string, extension: string, id_paquete: string, contratacion: string, desde: string, hasta: string, costo: string, estado: *[], usuarios: [{usuario: string, password: string, confirmacion: string, nombre: string, email: string, tel_movil: string}], correos: [{correo: string}], telefonos: [{telefono: string}]}}
 */
const valorInicial = {
    sistema : 'BGDL',
    cliente : "",
    origen : "Desconocido",
    contacto : "",
    email : "",
    tel_movil : "",
    tel_oficina : "",
    extension : "",
    id_paquete : "",
    contratacion : "Mensual",
    desde : dayjs().format('YYYY MMM DD'),
    hasta : dayjs().format('YYYY MMM DD'),
    costo : "",
    estado : [],
    usuarios : [
        {
            usuario : "",
            password : "",
            confirmacion : "",
            nombre : "",
            email : "",
            tel_movil : ""
        }
    ],
    correos : [
        {
            correo : "",
        }
    ],
    telefonos : [
        {
            telefono : ""
        }
    ]
};

/**
 * COMPONENTE PRINCIPAL
 * @param show manejo del modal
 * @param setShow
 * @returns {JSX.Element}
 * @constructor
 */
export default function CrearContrato({
    show,
    setShow
}) {
    /**
     * Hook, necesaria para cerrar Modal y cambiar path
     */
    const navigate = useNavigate()
    /**
     * Manejo de Wizzard
     */
    const [step, setStep] = useState(0);
    /**
     * Manejo de notificaciones
     * @type {undefined}
     * @property setArrayToast
     */
    const toastP = useToast();
    /**
     * Manejo de errores de API
     */
    const [errorApi, setErrorApi] = useState({});
    /**
     * Cambiar array de contratos
     */
    const { setContratos, results } = useContratos();
    /**
     * Usar recursos de finder
     */
    const {inputSearch, } = useSearch();

    /**
     * @function onSubmit Limpiar datos y enviar datos al servidor
     * @param values
     */
    function onSubmit(values){
        /**
         * Cabiar arreglo de objetos a arreglo de cadena / números y limpiar cadena de teléfonos
         * @type {(string|*)[]}
         */
        const mails = values.correos.map((c) => c.correo);
        const tel = values.telefonos.map((m) => m.telefono.replaceAll('-',''));
        const usr = values.usuarios.map((u) => ({
            usuario : u.usuario,
            password : u.password,
            confirmacion : u.confirmacion,
            nombre : u.nombre,
            email : u.email,
            tel_movil : u.tel_movil.replaceAll('-', ''),
        }));

        /**
         * Enviar datos al servidor
         */
        axiosInstance.post('/contratos', {
            sistema : values.sistema,
            cliente : {
                cliente : values.cliente,
                origen : values.origen,
                contacto : values.contacto,
                email : values.email,
                tel_movil : values.tel_movil.replaceAll('-', ''),
                tel_oficina: values.tel_oficina.replaceAll('-',''),
                extension : values.extension,
            },
            paquete : {
                id_paquete : values.id_paquete,
                contratacion : values.contratacion,
                estados: values.estado,
            },
            usuarios : usr,
            notificaciones : {
                correos: mails,
                telefonos : tel
            }
        })
            .then((response) => {
                if(response.status === 200) {
                    /**
                     * se piden los datos del nuevo contrato a finder (con el nombre del cliente
                     */
                    inputSearch(values.usuarios[0].usuario);
                    /**
                     * Cambiar array de contratos : mostrarlos en la tabla contratos
                     */
                    setContratos(results);
                    /**
                     * Notificación::success
                     */
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id : values.sistema,
                                text: "Contrato de " + values.cliente + " creado",
                                color: 'success',
                                show: true
                            }
                        ]
                    );
                    /**
                     * Limpiar inputs y estados
                     */
                    handleClose();
                }
            }).catch((error) => {
                /**
                 * Desactivar boton de 'Enviar'
                 */
                setStatus(true);

                if (error.response.data){
                    /**
                     * Notificación::error (en los datos)
                     */
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id : values.sistema,
                                text: error.response.data.errors[0].message,
                                color: 'danger',
                                show: true
                            }
                        ]
                    );
                    /**
                     * Array de los atributos del objeto "value" (datos de formulario)
                     * @type {string[]}
                     */
                    const keys = Object.keys(values);
                    /**
                     * Array del input ( error de la API )
                     * @type {string[]}
                     */
                    const input = `${error.response.data.errors[0].input}`.split('.');
                    /**
                     * Asignar los errores a los campos correspondientes de formik
                     */
                    if (input[0] === "usuarios"){

                        setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);

                        setErrorApi({
                            ...errorApi,
                            field : input[0],
                            input : error.response.data.errors[0].input,
                            message : error.response.data.errors[0].details,
                        })

                    } else if (input[1] === "correos"){
                        setFieldError(`correos.${input[2]}.correo`, `${error.response.data.errors[0].details}`);

                        setErrorApi({
                            ...errorApi,
                            field : "correos",
                            input : `correos.${input[2]}.correo`,
                            message : error.response.data.errors[0].details,
                        })

                    } else if (input[1] === "telefonos"){
                        setFieldError(`telefonos.${input[2]}.telefono`, `${error.response.data.errors[0].details}`);

                        setErrorApi({
                            ...errorApi,
                            field : "telefonos",
                            input : `telefonos.${input[2]}.telefono`,
                            message : error.response.data.errors[0].details,
                        })
                    } else if (keys.some(k => k === input[1])){

                        setFieldError(input[1], `${error.response.data.errors[0].details}`);

                        setErrorApi({
                            ...errorApi,
                            field : input[1],
                            input : input[1],
                            message : error.response.data.errors[0].details,
                        })

                    } else {

                        setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);

                        setErrorApi({
                            ...errorApi,
                            field : error.response.data.errors[0].input,
                            input : error.response.data.errors[0].input,
                            message : error.response.data.errors[0].details,
                        })
                    }
                } else{
                    /**
                     * Notificación::error (no se encontro el input)
                     */
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id : values.sistema,
                                text: 'Error en los datos',
                                color: 'danger',
                                show: true
                            }
                        ]
                    );
                }
            });
    }

    /**
     * Manejo del formulario
     */
    const formik = useFormik({
        initialValues : valorInicial,
        validationSchema : validacionContrato[step],
        enableReinitialize : true,
        onSubmit
    });

    /**
     * Desestructuración del objeto formik ( evita que useEffect caiga en un bucle infinito )
     */
    const { validateForm, setFieldError, status, setStatus } = formik;
    /**
     * Validar los valores en cuanto el componente se monta
     */
    useEffect(() => {
        /**
         * Array de los campos que se estan validando
         * @type {string[]}
         */
        const validacionObj = Object.keys(validacionContrato[step].fields);
        /**
         * Sí hay errores (que vengan de la API) vuelve a asignar el error al campo correspondiente de formik //////
         * Se asignan los errores nuevamente porque la funcion validateForm() solo toma en cuenta los errores originales (validationSchema)
         * y sobreescribe los que se asignan con setFieldError
         */
        if (Object.keys(errorApi).length > 0 && validacionObj.some((v) => v === errorApi.field)) {

            setFieldError(`${errorApi.input}`, `${errorApi.message}`);
            setStatus(false);
        } else {
            /**
             * En caso contrario de valida el formulario
             */
            validateForm().then(r => r);

        }

    }, [ step, validateForm, errorApi, setFieldError, setStatus]);
    /**
     * Estados para guardar arreglos de catalogos
     */
    const [catalogo, setCatalogo] = useState({});
    const [sistema, setSistema] = useState('BGDL');
    const [paqueteArray, setPaqueteArray] = useState([]);

    /**
     * @function handleClose Limpiar valores y estados del formulario
     */
    function handleClose(){
        formik.resetForm();
        setShow(false);
        setStep(0);
        setSistema('BGDL');
        navigate(-1);
        setErrorApi({});
    }

    /**
     * Obtener catalogos de servidor o localStorage
     */
    useEffect(() => {
        const catalogosLS = JSON.parse(localStorage.getItem("catalogosContratos")) ?? [];

        if (Object.keys(catalogosLS).length > 0){
            setCatalogo(catalogosLS);
        } else{
            axiosInstance.get('/catalogos?list=sistemas,periocidades,origenes')
                .then(res => {
                    setCatalogo(res.data);
                    localStorage.setItem("catalogosContratos", JSON.stringify(res.data));
                }).catch(err => console.log(err));
        }
    },[]);
    /**
     * Se cambian los paquetes según el sistema elegido
     */
    useEffect(() => {
        //localStorage.setItem("sistemaContratos", JSON.stringify(sistema));
        /**
         * Solo se hace la petición al servidor una vez por cada paquete
         */
        switch (sistema) {
            case 'BGDL':
                const paquetesBoletin = JSON.parse(localStorage.getItem("paquetesBoletin"));
                if ( Array.isArray(paquetesBoletin) ){
                    setPaqueteArray(paquetesBoletin);
                } else {
                    axiosInstance.get('/paquetes?sistema=' + sistema)
                        .then(res => {
                            if (Array.isArray(res.data)) {
                                setPaqueteArray(res.data);
                                localStorage.setItem("paquetesBoletin", JSON.stringify(res.data));
                            }
                        }).catch(err => console.log(err));
                }
                break;
            default:
                const paquetesEJ = JSON.parse(localStorage.getItem("paquetesEJ"));
                if (Array.isArray(paquetesEJ)){
                    setPaqueteArray(paquetesEJ);
                } else {
                    axiosInstance.get('/paquetes?sistema=' + sistema)
                        .then(res => {
                            if (Array.isArray(res.data)){
                                setPaqueteArray(res.data);
                                localStorage.setItem("paquetesEJ", JSON.stringify(res.data));
                            }
                        }).catch(err => console.log(err));
                }
                break;
        }
    }, [sistema]);
    /**
     * Total de números de celular
     */
    const [totalW, setTotalW] = useState([]);
    /**
     * Total de cuentas de correo
     */
    const [totalM, setTotalM] = useState([]);
    /**
     * En caso de contar con notificaciones, se saca del objeto del paquete elegido la cantidad de números de teléfonos o correos permitidos
     */
    useEffect(() => {
        const conceptoP = paqueteArray ? paqueteArray.find(p => p.id_paquete === formik.values.id_paquete) : null;

        if (conceptoP) {
            const whats = conceptoP.conceptos.find((a) => a.id_concepto === "18000");
            const mail = conceptoP.conceptos.find((a) => a.id_concepto === "15000");

            if (whats) {
                setTotalW(Array.from({length: whats.valor}, (_, i) => i + 1));
            } else setTotalW([]);

            if (mail) {
                setTotalM(Array.from({length: mail.valor}, (_, i) => i + 1));
            } else setTotalM([]);

        }
    },[formik.values.id_paquete, paqueteArray])


    /**
     * @prop catalogos.sistemas
     * @prop catalogo.origenes
     * @prop catalogo.periocidades
     */

    return (
        <>
            <style type={'text/css'}>
                {`
                    .form-floating > label::after {
                        background-color: var(--bs-gray-100)!important;
                    }
                    
                    .rs-check-item .rs-checkbox-checker .rs-checkbox-control{
                        display: none!important;
                    }
                    
                    .rs-picker-textbox{
                        background-color:var(--bs-gray-100)!important;
                        padding-top: 0.5rem;
                        border: 0!important;
                        margin-right:0!important;
                        border-radius: .475rem!important;
                    }
                    
                    .rs-check-item .rs-checkbox-checker > label{
                        padding : 8px 12px;
                    }
                    
                    .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
                        color : var(--bs-text-gray-700)!important;
                        font-size : 1.1rem!important;
                        font-weight : 500!important;
                    }
                    
                `}
            </style>
            <Modal show={show} fullscreen={true} onHide={handleClose} keyboard={false} autoFocus={true}>
                <Modal.Header closeButton tabIndex={-1}>
                    <div className="d-flex justify-content-center align-items-center">
                        <i className="ki-solid ki-feather fs-3qx text-primary"></i>
                        <span className="modal-title h3 ps-2"> Crear Contrato </span>
                    </div>
                </Modal.Header>
                <Modal.Body className={"py-7 align-content-center"}>
                    <div className={"container d-grid d-md-flex align-items-center justify-content-center"}>
                        <FormContrato step={step} formik={formik} setSistema={setSistema} catalogo={catalogo} paqueteArray={paqueteArray} totalW={totalW} totalM={totalM}></FormContrato>
                    </div>
                </Modal.Body>
                <Modal.Footer className={"d-flex"}>
                    <button type={'button'} className={"btn btn-secondary me-5"} onClick={handleClose}>
                        Cancelar
                    </button>
                    {
                        step > 0 ? (<div className="mr-2">
                            <button type="button" className="btn btn-light-primary me-3"
                                    onClick={() => setStep(step - 1)}
                            >
                                <i className="ki-duotone ki-arrow-left fs-4 rotate-180">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                                Atras
                            </button>
                        </div>) : (<div></div>)
                    }
                    <div>
                        <button form={"contrato-nuevo"} type={'submit'} className={"btn btn-primary me-3 " + (step < 4 && "d-none" )} disabled={status || Object.keys(formik.errors).length > 0}>
                            <span className="indicator-label"> Enviar
                                <i className="ki-duotone ki-arrow-right fs-4 ms-2 me-0">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </span>
                        </button>
                        <button type="button" className={"btn btn-primary " + (step === 4 && "d-none")} onClick={() => setStep(step + 1)}
                                //nextStep
                                disabled={Object.keys(formik.errors).length > 0}
                        >
                            Continuar
                            <i className="ki-duotone ki-arrow-right fs-4 ms-1 me-0">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

/**
 *
 * @param step del formulario
 * @param formik funciones y valores del formulario
 * @param setSistema
 * @param catalogo
 * @param paqueteArray
 * @param totalW
 * @param totalM
 * @returns {JSX.Element}
 * @constructor
 */

////// LAYOUT::Steps y Form //////
function FormContrato({
    step,
    formik,
    setSistema,
    catalogo,
    paqueteArray,
    totalW,
    totalM
}) {
    return (
        <>
            <div className="content d-flex flex-column flex-column-fluid pt-8" id="nuevo-contrato">
                {/*<div className="container-xxl">*/}
                <div className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid gap-10" id="kt_create_account_stepper">
                    <div className="card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px" style={{border: "1px solid var(--bs-card-border-color)"}}>
                        <div className="card-body px-6 px-lg-10 px-xxl-15 py-20">
                            <div className="stepper-nav">
                                <div className={"stepper-item " + (step === 0 ? "current" : step > 0 ? "completed" : "")} >
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">1</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Sistema</h3>
                                            <div className="stepper-desc fw-semibold">Applicaci&oacute;n a contratar.</div>
                                        </div>
                                    </div>
                                    <div className="stepper-line h-40px"></div>
                                </div>
                                <div className={"stepper-item " + (step === 1 ? "current" : step > 1 ? "completed" : "")} >
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">2</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Contacto</h3>
                                            <div className="stepper-desc fw-semibold">Información de contacto</div>
                                        </div>
                                    </div>
                                    <div className="stepper-line h-40px"></div>
                                </div>
                                <div className={"stepper-item " + (step === 2 ? "current" : step > 2 ? "completed" : "")} >
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">3</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Paquete</h3>
                                            <div className="stepper-desc fw-semibold">Características del contrato.</div>
                                        </div>
                                    </div>
                                    <div className="stepper-line h-40px"></div>
                                </div>
                                <div className={"stepper-item " + (step === 3 ? "current" : step > 3 ? "completed" : "")} >
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">4</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Usuarios</h3>
                                            <div className="stepper-desc fw-semibold">Credenciales de acceso.</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="stepper-line h-40px"></div>
                                <div className={"stepper-item " + (step === 4 ? "current" : Object.keys(formik.errors).length === 0 && step === 4 ? "completed" : "")}
                                     // mark-completed
                                >
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">5</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Notificaciones</h3>
                                            <div className="stepper-desc fw-semibold">Para envío de reportes.</div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="stepper-line h-40px"></div>*/}
                                {/*<div className={"stepper-item mark-completed " + (step === 5 ? "completed" : "")} >*/}
                                {/*    <div className="stepper-wrapper">*/}
                                {/*        <div className="stepper-icon w-40px h-40px">*/}
                                {/*            <i className="ki-duotone ki-check fs-2 stepper-check"></i>*/}
                                {/*            <span className="stepper-number">6</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="stepper-label">*/}
                                {/*            <h3 className="stepper-title">Resumen</h3>*/}
                                {/*            <div className="stepper-desc fw-semibold">Datos de contrataci&oacute;n.</div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                    <div className="card d-flex flex-row-fluid flex-center" style={{border: "1px solid var(--bs-card-border-color)"}}>
                        <FormikProvider value={formik}>
                            <form id={"contrato-nuevo"} className="card-body py-20 w-100 mw-xl-700px px-9" onSubmit={formik.handleSubmit}>
                                <div className={step === 0 ? "current" : ""} data-kt-stepper-element="content">
                                    <Step1 formik={formik} catalogo={catalogo} setSistema={setSistema}></Step1>
                                </div>
                                <div className={step === 1 ? "current" : ""} data-kt-stepper-element="content">
                                    <Step2 formik={formik} catalogo={catalogo} step={step}></Step2>
                                </div>
                                <div className={step === 2 ? "current" : ""} data-kt-stepper-element="content">
                                    <Step3 formik={formik} catalogo={catalogo} paqueteArray={paqueteArray}></Step3>
                                </div>
                                <div className={step === 3 ? "current" : ""} data-kt-stepper-element="content" >
                                    <Step4 formik={formik} paqueteArray={paqueteArray} step={step}></Step4>
                                </div>
                                <div className={step === 4 ? "current" : ""} data-kt-stepper-element="content">
                                    <Step5 formik={formik} paqueteArray={paqueteArray} totalW={totalW} totalM={totalM}></Step5>
                                </div>
                                {/*<div className={step === 5 ? "current" : ""} data-kt-stepper-element="content">*/}
                                {/*    <Step6></Step6>*/}
                                {/*</div>*/}
                            </form>
                        </FormikProvider>
                    </div>
                </div>
                {/*</div>*/}
            </div>
        </>
    );
}
